
import { defineComponent, reactive } from 'vue'
import { maska } from 'maska'

import useVuelidate from '@vuelidate/core'
import { required } from '@vuelidate/validators'

export default defineComponent({
    directives: {
        maska,
    },
    props: {
        disabled: {
            type: Boolean,
            default: false,
        },
        completed: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['submit', 'close'],
    setup(props, { emit }) {
        const state = reactive({
            name: null as string | null,
            phone: null as string | null,
            company: null as string | null,
            is_agree: false,
            is_submitted: false,
        })

        const v$ = useVuelidate(
            {
                name: { required },
                phone: { required },
            },
            state
        )

        const toggleCheckbox = () => {
            if (props.disabled) return
            state.is_agree = !state.is_agree
        }

        const onClose = () => {
            if (props.disabled) return
            emit('close')
        }

        const onSubmit = () => {
            if (props.disabled) return

            state.is_submitted = true

            v$.value.$touch()
            if (v$.value.$invalid) return

            if (!state.is_agree) return

            emit('submit', {
                name: state.name,
                phone: state.phone,
                company: state.company,
            })
        }

        return {
            state,
            v$,
            toggleCheckbox,
            onClose,
            onSubmit,
        }
    },
})
